function onSignIn(googleUser) {
  console.log('On Sign In User', googleUser)

  let profile = googleUser.getBasicProfile()
  console.log(profile)

  const config = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'bearer: pPc8CMC0W8UQNIEG-H5d2CjDpfzoQqXM',
    },
  }

  let isCargoUser =
    locationHref.substring(locationHref.indexOf('?') + 1) === 'cargoUser'
  console.log('IS CARGO USER ' + isCargoUser)

  fetch(
    'https://api.kitbash3d.com/api/Shopify/GenerateToken?email=' +
      profile.getEmail(),
    config,
  )
    .then((res) => res.text())
    .then((token) => {
      try {
        const redirectUrl = (window.location.href =
          '/account/login/multipass/' + token)
      } catch (error) {
        console.log(error)
      }
    })
    .then((resp) => {
      if (isCargoUser) {
        window.setTimeout(() => {
          window.location = '/pages/cargo'
        }, 800)
      }
    })
}

function signOut() {
  console.log('User Logged out Successfully')
  var auth2 = gapi.auth2.getAuthInstance()
  auth2.signOut().then(function () {
    window.location.href = '/account/logout'
  })
}
